'use client'

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'

const UiCollapsible = CollapsiblePrimitive.Root

const UiCollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger

const UiCollapsibleContent = CollapsiblePrimitive.CollapsibleContent

export { UiCollapsible, UiCollapsibleContent, UiCollapsibleTrigger }
